<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5339 5.27734L12.5339 7.07234L8.0006 11.102L3.46727 7.07234L3.46727 5.27734L4.53394 5.27734L4.53394 6.59333L8.0006 9.67485L11.4673 6.59333L11.4673 5.27734L12.5339 5.27734Z"
            fill="white"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
